export const createTableHeadColumns = ({ language }) => [
    {
        text: language?.reports?.events ?? "Events",
        accessor: "title",
    },
    {
        text: language?.reports?.event_match_quality ?? "Event Match Quality",
    },
    {
        text: language?.reports?.event_count ?? "Total Events",
        accessor: "event",
    },
    {
        text: language?.reports?.total_errors ?? "Total Errors",
        accessor: "errors",
    },
];
